import { Component, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { APPCONFIG } from "../../config";
import { Http, Headers } from "@angular/http";
import { RequestService } from "../requests.service";
import { ErrorHandler } from "../../shared/services/error-handler.service";
import { HttpService } from "../../shared/services/http.service";
import { LayoutService } from "../../layout/layout.service";
import { SessionHandler } from "../../shared/services/session-handler.service";
import { CommonService } from "../../shared/services/common.service";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormArray,
} from "@angular/forms";
import { itemClass, itemClassEdit, itemClassEditManual } from "./itemClass";
import { MdDialog, MdDialogRef } from "@angular/material";
import { dialogComponent } from "../../dialog/dialog.component";
import { FileUploader } from "ng2-file-upload";

@Component({
  selector: "return-invoice",
  template: require('./return.component.html'),
  styles: [require('./return.component.scss')],
  providers: [HttpService, ErrorHandler, SessionHandler, RequestService],
})
export class RequestReturnComponent {
  URL: any = APPCONFIG.appUrlBase + "/uploadCsvFile"; // prod
  uploader;
  headers: any;
  filesUploaded: any;
  showUploaded: any;
  showStaticUploaded: any;
  filesArray: any;
  data: any;
  newData: any;
  radioValue: any;
  errorMessageRadioSelection: any;
  iterationNumber: any;

  requestReturnForm: FormGroup;
  requestFormData: any;
  returnOrder: any = {};
  userData: any = {};
  dialogRef;
  isAdmin: boolean = false;
  reasonList: any;
  isEdit: boolean = false;
  isFocOrder: any;
  id: any;
  invoice_no: any = [];
  invoice_no_array: any = [];
  return_reason: any;
  modelNumber: any;
  spareNumber: any;
  serialNumber: any;
  serialNumberSpare: any;
  quantity: any = "1";
  quantitySpare: any = "1";
  last_index: any = 0;
  nc_number: any;
  quantityNC: any = "1";
  ncNumber: any;
  serialNumber12NC: any;

  //arrays
  items: any = [];
  spareList: any = [];
  item_list: any = [];
  enableItemReason: any = [];
  listValid: any = [];
  itemReason: any = [];
  serialNumberList: any = [];
  serialNumberInput: any = [];
  itemQuantityList: any = [];
  itemQuantity: any = [];
  showEditSerial: any = [];
  listLoader: any = [];
  listError: any = [];
  invoiceNo: any = [];

allSpareList: any[] = [];
filteredSpareList: any[] = [];
allModelList: any[] = [];
filteredModelList: any[] = [];

  //return method
  isManual: boolean = false;
  isUpload: boolean = false;
  load: boolean = false;

  //buttons and content checks
  nextBtnEnable: boolean = false;
  enableInvoiceCheck: boolean = false;
  invoiceBtnEnable: boolean = false;
  showInsertButton: boolean = true;
  showInvoiceReturn: boolean = false;
  showAddToListBtn: boolean = false;
  showInvoiceList: boolean = false;
  showManualList: boolean = false;
  isD2CUser: boolean = false;
  @ViewChild("invoiceFileInput") invoiceFileInput: any;

  d2cCommentReason: any = ""; /**Added for d2c user flow */

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private Http: Http,
    private http: HttpService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private sessionHandler: SessionHandler,
    private dialog: MdDialog
  ) {
    if (this.http.checkSession()) {
      //file upload initialize
      this.uploader = new FileUploader({
        url: this.URL,
        disableMultipart: true,
      });

      //check if draft mode
      this.route.params.subscribe((params) => {
        this.id = +params["id"];
      });
      if (!isNaN(this.id)) {
        this.isEdit = true;
      }

      //user data and admin checks
      this.userData = JSON.parse(this.sessionHandler.getItem("loginData"));
      if (this.userData) {
        if (this.userData.role && this.userData.role.length > 0) {
          if (
            this.userData.role.includes("ADMIN") ||
            this.userData.role.includes("OTD_APPROVER") ||
            this.userData.role.includes("END_CONSUMER")
          ) {
            this.isAdmin = true;
          }
          // ****Old****
          // for (let u in this.userData.role) {
          //     if (this.userData.role[u] == 'ADMIN' || this.userData.role[u] == 'OTD_APPROVER' || this.userData.role[u] == 'END_CONSUMER') {
          //         this.isAdmin = true;
          //     }
          // }
        } else {
          this.showError("No role assigned to user. Please login again.", true);
        }
      } else {
        this.showError("No login data found. Please login again.", true);
      }

      //reasonsList check
      this.reasonList = JSON.parse(this.sessionHandler.getItem("reasons"));
      if (this.reasonList == null || this.reasonList.length < 0) {
        this.getReasonList();
      }
      this.allSpareList = JSON.parse(this.sessionHandler.getItem("spare")) || [];

      if (this.allSpareList.length > 0) {
        this.spareList = this.allSpareList;
        this.filteredSpareList = this.allSpareList.slice(0,100);
      } else {
        this.getAllSpare();
      }


      this.allModelList = JSON.parse(this.sessionHandler.getItem("models")) || [];

      if (this.allModelList.length > 0) {
        this.filteredModelList = this.allModelList.slice(0,100);
      } else {
        this.getAllModels();
      }

      //form data checks
      let requestData = this.commonService.getData();
      console.log(requestData);
      if (requestData) {
        this.requestFormData = requestData;
        this.isD2CUser =
          requestData.isD2CUser; /**added for  D2c one time address */
        if (this.requestFormData["returnOrder"]) {
          this.returnOrder = this.requestFormData["returnOrder"];
          this.commonService.changeViewData(requestData);
        }
      } else if (this.isEdit) {
        this.getRequestDataWithId();
      } else {
        this.router.navigateByUrl("/app/requests/create");
      }
    } else {
      this.http.showSessionError();
    }
  }

  ngOnInit() {
    this.buildForm();
    this.onAddProperty();
    if (this.returnOrder && Object.keys(this.returnOrder).length > 0) {
      // this.setReturnData();
      if (
        this.requestFormData.returnItemUploadFlag == 2 ||
        this.requestFormData.returnItemUploadFlag == "INVOICE_NUMBER"
      ) {
        this.setReturnData();
      } else if (
        this.requestFormData.returnItemUploadFlag == 0 ||
        this.requestFormData.returnItemUploadFlag == 1 ||
        this.requestFormData.returnItemUploadFlag == "INSERT_MANUAL" ||
        this.requestFormData.returnItemUploadFlag == "UPLOAD_FILE"
      ) {
        this.setReturnDataManual();
      }
    }
  }

  public buildForm() {
    this.requestReturnForm = this.formBuilder.group({
      reason: this.formBuilder.control(
        this.returnOrder.reason ? this.returnOrder.reason : null,
        [Validators.required]
      ),
      isFocOrder: this.formBuilder.control(false, []),
      //invoiceNumber: this.formBuilder.control({value: this.returnOrder.invoiceNumber ? this.returnOrder.invoiceNumber :null,disabled:false},[Validators.required])
      invoiceNumber: this.formBuilder.array([]),
      isD2CUser: this.formBuilder.control(
        this.isD2CUser,
        []
      ) /**added for  D2c one time address */,
      d2cComments: this.formBuilder.control(
        "",
        []
      ) /**added for  D2c one time address */,
    });

    // this.requestReturnForm.valueChanges.subscribe(data => {
    // });

    this.requestReturnForm.get("isFocOrder").valueChanges.subscribe((data) => {
      console.log(data);
    });

    this.requestReturnForm
      .get("invoiceNumber")
      .valueChanges.subscribe((data) => {
        this.invoiceNo = data;
        if (data) {
          if (data[0] != null) {
            this.enableInvoiceCheck = true;
            this.isManual = false;
            this.isUpload = false;
            this.invoiceBtnEnable = false;
          }
        } else {
          this.enableInvoiceCheck = false;
        }
      });
    this.requestReturnForm.get("reason").valueChanges.subscribe((data) => {
      if (data) {
        this.setD2cComment(data); /**Added for d2c user flow */
        if (!this.isManual && !this.isUpload) {
          // this.checkItemCount();
          this.setDefaultReason();
        } else if (this.isManual || this.isUpload) {
          // this.checkItemCountManual();
          this.setDefaultReasonManual();
        }
      }
    });
  }
  setD2cComment(data) {
    if (this.reasonList) {
      for (let i = 0; i<this.reasonList.length; i++) {
        if (data == this.reasonList[i].reasonCode) {
          this.d2cCommentReason = this.reasonList[i].reason;
          break;
        }
      }
    }
  }
  public onAddProperty(index?: any, data?: any): void {
    const arrayControl = <FormArray>(
      this.requestReturnForm.controls["invoiceNumber"]
    );
    arrayControl.push(new FormControl());
  }

  delPropertyByIndex(index: number, invoiceLength: number): void {
    if (invoiceLength > 0) {
      const arrayControl = <FormArray>(
        this.requestReturnForm.controls["invoiceNumber"]
      );
      arrayControl.removeAt(index);
    }
    if (invoiceLength == 1) {
      this.onAddProperty();
      this.reset("invoice");
    }
  }

  resetInvoieFields() {
    if (this.requestReturnForm.controls["invoiceNumber"]) {
      const arrayControl = <FormArray>(
        this.requestReturnForm.controls.invoiceNumber
      );
      arrayControl.controls = [];
      arrayControl.push(new FormControl());
    }
  }

  public getAllSpare() {
    this.http.getRequest("tradePartnerDetails/v1/getAllSpareParts").subscribe(
      (response) => {
        console.log(response);
        this.saveSpareList(response);
      },
      (err) => {
        if (err && err.status != 0) {
          this.dialogRef = this.dialog.open(dialogComponent);
          this.dialogRef.componentInstance.msg = err;
        }
        this.http.onEnd();
      }
    );
  }
  public getSpareList() {
    if (this.spareNumber === null) {
      console.log("not correct");
    } else {
      console.log(this.spareNumber);
      this.http
        .getRequestWithoutLoader("tradePartnerDetails/v1/getAllSpareParts")
        .subscribe(
          (response) => {
            console.log(response);
            this.saveSpareList(response);
            this.http.onEnd();
          },
          (err) => {
            if (err && err.status != 0) {
              this.dialogRef = this.dialog.open(dialogComponent);
              this.dialogRef.componentInstance.msg = err;
            }
            this.http.onEnd();
          }
        );
    }
  }

  public getAllModels() {
  this.http.getRequest("masterData/v1/getAllMaterials?isFOC=false").subscribe(
    (res: any) => {
      this.saveModelList(res);
    },
    err => {
      if (err && err.status != 0) {
        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg = err;
      }
      this.http.onEnd();
    }
  );
}

public saveModelList(res) {
  if (res && res.modelList && Array.isArray(res.modelList)) {

    this.allModelList = res.modelList
      .filter(item => item && item.comm_code)
      .map(item => ({
        comm_code: String(item.comm_code || '').trim(),
        description: String(item.description || '').trim()
      }));

    this.filteredModelList = this.allModelList.slice(0,100);

    this.sessionHandler.saveItem(
      "models",
      JSON.stringify(this.allModelList)
    );

    this.http.onEnd();

  } else {
    this.allModelList = [];
    this.filteredModelList = [];
    this.showError("Not able to fetch model list.", false);
    this.http.onEnd();
  }
}
public getHighlightedParts(
  text: string,
  search: string
): { value: string; match: boolean }[] {

  if (!text) {
    return [{ value: '', match: false }];
  }

  const term = (search || '').trim();

  if (!term) {
    return [{ value: text, match: false }];
  }

  const lowerText = text.toLowerCase();
  const lowerTerm = term.toLowerCase();

  const index = lowerText.indexOf(lowerTerm);

  if (index === -1) {
    return [{ value: text, match: false }];
  }

  const parts: { value: string; match: boolean }[] = [];

  if (index > 0) {
    parts.push({
      value: text.substring(0, index),
      match: false
    });
  }

  parts.push({
    value: text.substring(index, index + term.length),
    match: true
  });

  if (index + term.length < text.length) {
    parts.push({
      value: text.substring(index + term.length),
      match: false
    });
  }

  return parts;
}
public getModelDisplay(item: any): string {
  if (!item) return '';

  const code = item.comm_code || '';
  const desc = item.description || '';

  if (code && desc) {
    return code + ' - ' + desc;
  }

  return code || desc;
}

public filterModelList(value: string) {
  const term = (value || '').toLowerCase().trim();

  if (!term) {
    this.filteredModelList = this.allModelList.slice(0,100);
  } else {
    
this.filteredModelList = this.allModelList
  .filter(item =>
    (item.comm_code || '').toLowerCase().includes(term) ||
    (item.description || '').toLowerCase().includes(term)
  )
  .slice(0, 50);
  }
}


  public getReasonList() {
    this.http.getRequest("tradePartnerDetails/v1/getReasonCode").subscribe(
      (res) => {
        this.saveReasonList(res);
      },
      (err) => {
        if (err && err.status != 0) {
          this.dialogRef = this.dialog.open(dialogComponent);
          this.dialogRef.componentInstance.msg = err;
        }
        this.http.onEnd();
      }
    );
  }

  public saveReasonList(res) {
    if (res && res.items) {
      this.reasonList = res.items;
      this.sessionHandler.saveItem("reasons", JSON.stringify(this.reasonList));
      this.http.onEnd();
    } else {
      this.showError("Not able to fetch reason list.", false);
    }
  }
  
  public saveSpareList(res) {
    if (res && res.items) {
      this.allSpareList = res.items || [];
      this.spareList = this.allSpareList;
      this.filteredSpareList = this.allSpareList.slice(0,100);

      this.sessionHandler.saveItem("spare", JSON.stringify(this.allSpareList));
      this.http.onEnd();
    } else {
      this.showError("Not able to fetch spare list.", false);
      this.http.onEnd();
    }
  }
public filterSpareList(value: string) {
  const term = (value || '').toLowerCase().trim();

  if (!term) {
    this.spareNumber = null;
    this.filteredSpareList = this.allSpareList.slice(0,100);
    return;
  }

  
this.filteredSpareList = this.allSpareList
  .filter(spare =>
      spare.toLowerCase().includes(term)
  )
  .slice(0, 50);
}

  public getRequestDataWithId() {
    this.http
      .getRequest("returnOrder/v1/getReturnOrder?orderId=" + this.id)
      .subscribe(
        (res) => {
          this.saveRequestData(res);
        },
        (err) => {
          if (err && err.status != 0) {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = err;
          }
          this.http.onEnd();
        }
      );
  }

  public saveRequestData(res) {
    if (res.responseStatus == "Success") {
      this.requestFormData = res.returnReqDto;
      this.returnOrder = res.returnReqDto.returnOrder;
      this.commonService.changeViewData(res.returnReqDto);
      // this.setReturnData();
      if (
        this.requestFormData.returnItemUploadFlag == 2 ||
        this.requestFormData.returnItemUploadFlag == "INVOICE_NUMBER"
      ) {
        this.setReturnData();
      } else if (
        this.requestFormData.returnItemUploadFlag == 0 ||
        this.requestFormData.returnItemUploadFlag == 1 ||
        this.requestFormData.returnItemUploadFlag == "INSERT_MANUAL" ||
        this.requestFormData.returnItemUploadFlag == "UPLOAD_FILE"
      ) {
        this.setReturnDataManual();
      }
      this.http.onEnd();
    } else {
      this.showError("Not able to fetch data. Please try again.", false);
      this.http.onEnd();
    }
  }

  public checkInvoiceNumber(data) {
    if (this.invoiceNo) {
      let tradeId;
      let exist = false;
      if (this.isAdmin) {
        tradeId = this.requestFormData.tradeId;
      } else {
        tradeId = this.userData.tradePartnerId;
      }
      let invoiceString: string = "";
      for (let i in this.invoiceNo) {
        if (this.invoiceNo[i]) {
          for (let iv in this.invoice_no_array) {
            if (this.invoiceNo[i] == this.invoice_no_array[iv]) {
              exist = true;
              this.dialogRef = this.dialog.open(dialogComponent);
              this.dialogRef.componentInstance.msg =
                "Invoice number: " + this.invoiceNo[i] + " already exists.";
              break;
            }
          }
          if (!exist) {
            invoiceString += "invoiceDocumentIds=" + this.invoiceNo[i] + "&";
          }
        }
      }
      if (!exist) {
        this.http
          .getRequest(
            "invoiceValidationApi/v2/validateInvoiceData?" +
              invoiceString +
              "salesOrgId=" +
              APPCONFIG.salesOrgId +
              "&tradePartnerId=" +
              tradeId
          )
          .subscribe(
            (res) => {
              this.saveInvoiceData(res);
            },
            (err) => {
              if (err && err.status != 0) {
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = err;
              }
              this.http.onEnd();
            }
          );
      }
    }
  }

  public saveInvoiceData(res) {
    this.invoice_no = this.invoiceNo;
    if (res.items) {
      if (res.items.length != this.invoiceNo.length) {
        let errorString = "Invalid Invoice Number(s): ";
        for (let i in this.invoiceNo) {
          let count = 0;
          for (let r in res.items) {
            if (res.items[r].invoiceDocumentId == this.invoiceNo[i]) {
              count++;
            } else {
              count--;
            }
          }
          if (count < 0) {
            errorString += this.invoiceNo[i] + ", ";
          }
        }
        if (errorString.indexOf(null) == -1) {
          errorString = errorString.replace(/,\s*$/, "");
          this.dialogRef = this.dialog.open(dialogComponent);
          this.dialogRef.componentInstance.msg = errorString;
        }
      }
      this.enableInvoiceCheck = true;
      this.nextBtnEnable = false;
      if (this.items.length == 0) {
        this.items = res.items;
        this.item_list = [];
        this.enableItemReason = [];
        this.listValid = [];
        this.itemReason = [];
        this.serialNumberList = [];
        this.serialNumberInput = [];
      } else {
        for (let i in res.items) {
          this.items.push(res.items[i]);
        }
      }

      if (this.items.length > 0) {
        for (var i = this.last_index; i < this.items.length; i++) {
          if (this.items[i] && this.items[i]["itemDTOs"]) {
            if (this.isEdit) {
              if (this.items[i]["itemDTOs"]) {
                this.item_list.push(this.items[i]["itemDTOs"]);
              } else {
                this.item_list.push(this.items[i]["data"]);
              }
            } else {
              this.item_list.push(this.items[i]["itemDTOs"]);
            }

            this.listError[i] = [];
            this.itemReason[i] = [];
            let listValid = [];
            let showEditSerial = [];
            let serialNumberList = [];
            let itemQuantityList = [];
            let itemQuantity = [];
            let enableItemReason = [];
            let itemReason = [];
            let serialNumberInput = [];
            if (
              Object.keys(this.item_list[i]).length >
              0 /*this.item_list[i].length > 0*/
            ) {
              for (let j in this.item_list[i]) {
                itemQuantityList[j] = [];
                listValid[j] = true;
                showEditSerial[j] = false;
                serialNumberList[j] = [];
                serialNumberInput[j] = [];
                this.listError[i][j] = [];
                this.itemReason[i][j] = [];
                enableItemReason[j] = false;
                this.invoice_no_array[i] =
                  this.item_list[i][j]["invoiceDocumentID"];
                this.item_list[i][j]["invoiceNumber"] =
                  this.items[i]["invoiceDocumentId"];
                this.item_list[i][j].serialNumber = [];
                this.item_list[i][j].valid = false;
                //this.item_list[i][j].itemID = this.item_list[i][j].itemID.replace(/^0+/, '');
                this.item_list[i][j].itemID = this.item_list[i][j].itemID;

                for (
                  var x = 0;
                  x <= this.item_list[i][j].invoicedQuantity;
                  x++
                ) {
                  itemQuantityList[j].push(x);
                  itemQuantity[j] = 0;
                }
                this.item_list[i][j].invoicedQuantity = 0;
              }
              this.itemQuantityList[i] = itemQuantityList;
              this.listValid[i] = listValid;
              this.showEditSerial[i] = showEditSerial;
              this.serialNumberList[i] = serialNumberList;
              this.itemQuantityList[i] = itemQuantityList;
              this.itemQuantity[i] = itemQuantity;
              this.enableItemReason[i] = enableItemReason;
              this.itemReason[i] = itemReason;
              this.serialNumberInput[i] = serialNumberInput;
              this.showInvoiceReturn = true;
              this.showInsertButton = false;
            }
          }
        }
        this.last_index = this.items.length;
      }
    } else if (!res.errorMessage) {
      this.dialogRef = this.dialog.open(dialogComponent);
      this.dialogRef.componentInstance.msg =
        "No items found for this model number.";
    } else if (res.errorMessage) {
      this.dialogRef = this.dialog.open(dialogComponent);
      this.dialogRef.componentInstance.msg = res.errorMessage;
      this.invoiceNo = null;
    }
    this.showInvoiceList = true;
    this.resetInvoieFields();
    this.checkItemCount();
    this.http.onEnd();
  }
  public get12NC(i, modelNumber) {
    console.log("12nc "+i);
    if (this.spareNumber !== null && this.modelNumber === null) {
      this.http
        .getRequestWithoutLoader(
          "tradePartnerDetails/v1/getSpareNC12Code?modelNumber=" +
            this.spareNumber
        )
        .subscribe(
          (res) => {
            this.save12NC(i, res);
          },
          (err) => {
            this.listLoader[i] = false;
            this.listValid[i] = false;
            this.listError[i] = err;
            this.http.onEnd();
          }
        );
    } else if (this.modelNumber !== null && this.spareNumber === null) {
      this.http
        .getRequestWithoutLoader(
          "tradePartnerDetails/v1/getNC12Code?modelNumber=" + modelNumber
        )
        .subscribe(
          (res) => {
            if(res!=null && res['status'] == "Error"){
              //  alert(res['errorMessage'])
              this.item_list[i].done = true;
               this.listLoader[i] = false;
               this.listValid[i] = false;
               this.listError[i] = res['errorMessage'];
               this.showError(res['errorMessage'],false);
               this.http.onEnd();
            }else{
            this.data = res;
            this.newData = this.data.items;
            this.iterationNumber = i;
            this.load = true;
            if (this.newData.length === 1) {
              this.save12NC(i, res);
            }
          }
          },
          (err) => {
            this.listLoader[i] = false;
            this.listValid[i] = false;
            this.listError[i] = err;
            this.http.onEnd();
          }
        );
    }
    // New 12NC search code
    else if (this.modelNumber === null && this.ncNumber !== null) {
      this.http
        .getRequestWithoutLoader(
          "tradePartnerDetails/v1/getModelNumber?code12Nc=" + this.ncNumber
        )
        .subscribe(
          (res) => {
            this.save12NCSWAP(i, res);
          },
          (err) => {
            this.listLoader[i] = false;
            this.listValid[i] = false;
            this.listError[i] = err;
            this.http.onEnd();
          }
        );
    } else if (this.modelNumber !== null && this.spareNumber !== null) {
      if (modelNumber === this.spareNumber) {
        this.http
          .getRequestWithoutLoader(
            "tradePartnerDetails/v1/getSpareNC12Code?modelNumber=" +
              this.spareNumber
          )
          .subscribe(
            (res) => {
              this.save12NC(i, res);
            },
            (err) => {
              this.listLoader[i] = false;
              this.listValid[i] = false;
              this.listError[i] = err;
              this.http.onEnd();
            }
          );
      } else if (modelNumber === this.modelNumber) {
        this.http
          .getRequestWithoutLoader(
            "tradePartnerDetails/v1/getNC12Code?modelNumber=" + modelNumber
          )
          .subscribe(
            (res) => {
              this.save12NC(i, res);
            },
            (err) => {
              this.listLoader[i] = false;
              this.listValid[i] = false;
              this.listError[i] = err;
              this.http.onEnd();
            }
          );
      }
    }
  }

  public close12NCDialog() {
    this.load = false;
  }

  public submitNC() {
    if (this.radioValue === undefined) {
      this.errorMessageRadioSelection = "* Please select 12NC number";
    } else {
      let modifiedData = {
        items: [this.radioValue],
        status: "Success",
        responseCode: "200",
        itemCount: "0",
      };
      let number = this.iterationNumber;
      this.load = false;
      this.save12NC(number, modifiedData);
      this.radioValue = undefined;
      this.errorMessageRadioSelection = "";
    }
  }

  public fileupload() {
    let formData = new FormData();
    for (let i in this.uploader.queue) {
      this.http.showLoader();
      formData.append("file", this.uploader.queue[i]._file);
      let headers = new Headers({
        apiKey: "AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y",
        "access-token": this.sessionHandler.getItem("token"),
      });
      this.sessionHandler.saveItem(
        "timestamp",
        Math.round(new Date().getTime() / 1000.0)
      );
      this.Http.post(this.URL, formData, { headers: headers })
        .toPromise()
        .then((res) => this.setUploadData(res.json()))
        .catch((error) => this.handleError(error));
    }
    this.invoiceFileInput.nativeElement.value = "";
  }

  public handleError(e) {
    this.showError(e, false);
    this.http.onEnd();
  }

  public setUploadData(res) {
    this.uploader = new FileUploader({ url: this.URL, disableMultipart: true });
    if (
      res.status == "Success" &&
      res.fileDto &&
      Object.keys(res.fileDto).length > 0
    ) {
      let items: itemClass[] = [];
      for (let i in res.fileDto) {
        if (!res.fileDto[i].matnr12NC) {
          res.fileDto[i].matnr12NC = "NA";
        }
        items.push(
          new itemClass(
            "",
            res.fileDto[i].modelNo,
            res.fileDto[i].serialNumber,
            res.fileDto[i].matnr12NC,
            res.fileDto[i].quantity,
            res.fileDto[i].modelStatus
          )
        );
      }
      for (let i in items) {
        this.item_list.push(items[i]);
      }
      if (Object.keys(this.item_list).length > 0) {
        for (let i in this.item_list) {
          this.serialNumberList[i] = [];
          this.itemQuantityList[i] = [];
          this.itemQuantity[i] = [];

          //set quantity dropdown for item
          for (var x = 0; x <= this.item_list[i].invoicedQuantity; x++) {
            // this.itemQuantityList[i].push(x);//***Old one */
            //*** Check for duplicasy*/
            if (!this.itemQuantityList[i].includes(x)) {
              this.itemQuantityList[i].push(x);
            }
          }

          //set serial number list if present
          if (
            this.item_list[i].serialNumber &&
            Object.keys(this.item_list[i].serialNumber).length > 0
          ) {
            for (let s in this.item_list[i].serialNumber) {
              let rawSerial = {};
              rawSerial["id"] = "";
              rawSerial["value"] = this.item_list[i].serialNumber[s];
              this.serialNumberList[i].push(rawSerial);
            }
          }
        }
      }

      for (let i in this.item_list) {
        //set quantity
        for (let q in this.itemQuantityList[i]) {
          if (
            this.itemQuantityList[i][q] == this.item_list[i].invoicedQuantity
          ) {
            this.itemQuantity[i] = this.itemQuantityList[i][q];
          }
        }
        if (this.item_list[i].valid == "Valid") {
          if (parseInt(this.itemQuantity[i]) > 0) {
            this.enableItemReason[i] = true;
            this.listValid[i] = true;
            if (!this.itemReason[i] && this.return_reason) {
              this.itemReason[i] = this.return_reason;
            }
          }
          for (let s in this.serialNumberList[i]) {
            if (this.SerialValidation(this.serialNumberList[i][s].value)) {
              //this.compareSerialQuantity(i);
            } else {
              this.listValid[i] = false;
              this.listError[i] =
                "Invalid Serial Number. Please enter valid serial number of length 9 or 10.";
              this.enableItemReason[i] = false;
              this.itemReason[i] = [];
            }
          }
        }

        if (this.item_list[i].valid == "Invalid") {
          this.listValid[i] = false;
          this.listError[i] =
            "Invalid Model Number. Please enter a valid model number.";
          this.enableItemReason[i] = false;
        }
      }
      this.showManualList = true;
      this.checkItemCountManual();
    } else {
      this.showError(
        "Error in reading file. Please upload a valid CSV file.",
        false
      );
    }
    let control = this.requestReturnForm.get("invoiceNumber");
    control.disable();
    this.http.onEnd();
  }

  public setReturnData() {
    this.return_reason = this.returnOrder.reason;
    if (
      this.requestFormData.returnItemUploadFlag == "INSERT_MANUAL" ||
      this.requestFormData.returnItemUploadFlag == "0" ||
      this.requestFormData.returnItemUploadFlag == 0
    ) {
      if (this.requestReturnForm) {
        let control = this.requestReturnForm.get("invoiceNumber");
        control.disable();
      }
      this.isManual = true;
      this.invoiceBtnEnable = true;
    } else if (
      this.requestFormData.returnItemUploadFlag == "UPLOAD_FILE" ||
      this.requestFormData.returnItemUploadFlag == "1" ||
      this.requestFormData.returnItemUploadFlag == 1
    ) {
      if (this.requestReturnForm) {
        let control = this.requestReturnForm.get("invoiceNumber");
        control.disable();
      }
      this.isUpload = true;
      this.invoiceBtnEnable = true;
    } else if (
      this.requestFormData.returnItemUploadFlag == "INVOICE_NUMBER" ||
      this.requestFormData.returnItemUploadFlag == "2" ||
      this.requestFormData.returnItemUploadFlag == 2
    ) {
      // this.invoice_no = this.returnOrder.invoiceNumber;
      if (this.returnOrder.invoiceNumber) {
        if (typeof this.returnOrder.invoiceNumber == "object") {
          this.invoice_no = this.returnOrder.invoiceNumber;
        } else {
          this.invoice_no = this.returnOrder.invoiceNumber.split(",");
          this.invoice_no.reverse();
        }
      }

      this.showInsertButton = false;
      this.showInvoiceReturn = true;
    } else {
      if (this.requestReturnForm) {
        let control = this.requestReturnForm.get("invoiceNumber");
        control.disable();
      }
      this.isManual = true;
      this.invoiceBtnEnable = true;
    }

    let localItemList = JSON.parse(this.sessionHandler.getItem("itemList"));
    for (let i in localItemList) {
      this.itemQuantityList[i] = [];
      for (let j in localItemList[i]) {
        this.itemQuantityList[i][j] = [];
        for (var x = 0; x <= localItemList[i][j].length - 1; x++) {
          this.itemQuantityList[i][j].push(x);
        }
      }
    }
    if (this.returnOrder.items) {
      this.items = this.returnOrder.items;
      this.last_index = this.items.length;
      let returnOrder = [];
      for (let i in this.returnOrder.items) {
        if (this.isEdit) {
          if (this.returnOrder.items[i]["itemDTOs"]) {
            returnOrder.push(this.returnOrder.items[i]["itemDTOs"]);
          } else {
            returnOrder.push(this.returnOrder.items[i]["data"]);
          }
        } else {
          returnOrder.push(this.returnOrder.items[i]["data"]);
        }
      }
      this.item_list = returnOrder;

      this.nextBtnEnable = true;
      if (this.item_list && this.item_list.length > 0) {
        let dataCount = 0;
        for (let i in this.item_list) {
          for (let j in this.item_list[i]) {
            if (this.item_list[i]["data"]) {
              if (dataCount == 0) {
                if (this.item_list[i]["data"][j].modelNumber) {
                  this.setItemList();
                  dataCount++;
                } else {
                  this.setItemDataForEdit();
                  dataCount++;
                }
              }
            } else {
              if (dataCount == 0) {
                if (this.item_list[i][j].modelNumber) {
                  this.setItemList();
                  dataCount++;
                } else {
                  this.setItemDataForEdit();
                  dataCount++;
                }
              }
            }
          }
        }
      }
    }
  }

  public setItemList() {
    for (let i in this.item_list) {
      this.serialNumberInput[i] = [];
      this.enableItemReason[i] = [];
      this.listValid[i] = [];
      this.showEditSerial[i] = [];
      this.serialNumberList[i] = [];
      this.itemQuantity[i] = [];
      this.itemReason[i] = [];
      this.listError[i] = [];

      for (let j in this.item_list[i]) {
        this.invoice_no_array[i] = this.item_list[i][j]["invoiceDocumentID"];
        if (parseInt(this.item_list[i][j].invoicedQuantity) > 0) {
          this.enableItemReason[i][j] = true;
          this.listValid[i][j] = true;
          this.showEditSerial[i][j] = false;
          this.serialNumberList[i][j] = [];
          this.serialNumberInput[i][j] = [];
          this.listError[i][j] = [];
          if (this.isManual) {
            this.item_list[i][j].done = true;
          }
          if (
            this.item_list[i][j].serialNumber &&
            Object.keys(this.item_list[i][j].serialNumber).length > 0
          ) {
            for (let x in this.item_list[i][j].serialNumber) {
              if (
                this.item_list[i][j].serialNumber[x] &&
                Object.keys(this.item_list[i][j].serialNumber[x]).length > 0
              ) {
                if (
                  !this.isItemInArray(
                    this.serialNumberList[i][j],
                    this.item_list[i][j].serialNumber[x].value
                  )
                ) {
                  this.serialNumberList[i][j].push(
                    this.item_list[i][j].serialNumber[x]
                  );
                }
              }
            }
          }

          for (let q in this.itemQuantityList[i][j]) {
            if (
              this.itemQuantityList[i][j][q] ==
              this.item_list[i][j].invoicedQuantity
            ) {
              this.itemQuantity[i][j] = this.itemQuantityList[i][j][q];
            }
          }

          let count = 0;
          for (let x in this.serialNumberList[i][j]) {
            if (
              this.serialNumberList[i][j][x].value &&
              this.serialNumberList[i][j][x].value != ""
            ) {
              count++;
            }
          }
          if (count < parseInt(this.item_list[i][j].invoicedQuantity)) {
            this.showEditSerial[i][j] = true;
          }
          if (this.item_list[i][j].reasonCode) {
            this.itemReason[i][j] = this.item_list[i][j].reasonCode;
          }
        }
      }
    }
    this.showInvoiceList = true;
  }

  public setItemDataForEdit() {
    if (this.item_list) {
      let serials: any = [];
      let qty: any = [];
      let models: any = [];
      let final: any = [];
      let items = [];
      let itemList: any = [];
      for (let i in this.item_list) {
        serials[i] = [];
        qty[i] = [];
        models[i] = [];
        final[i] = [];
        let dummyItems: itemClassEdit[] = [];
        items.push(dummyItems);

        itemList[i] = [];
        for (let j in this.item_list[i]) {
          if (this.item_list[i][j]) {
            if (!this.item_list[i][j].id) {
              this.item_list[i][j].id = "";
            }
            let reason = null;
            if (this.item_list[i][j].reasonCode) {
              reason = this.item_list[i][j].reasonCode;
            }
            let maxQuantity = "";
            if (
              this.item_list[i][j].maxQuantity &&
              this.item_list[i][j].maxQuantity != ""
            ) {
              maxQuantity = this.item_list[i][j].maxQuantity;
            }
            if (this.item_list[i][j].serialNumber) {
              items[i].push(
                new itemClassEdit(
                  this.item_list[i][j].id,
                  this.item_list[i][j].invoiceDocumentID,
                  this.item_list[i][j].customerMaterialNumber,
                  this.item_list[i][j].serialNumber,
                  this.item_list[i][j].itemID,
                  reason,
                  this.item_list[i][j].invoicedQuantity,
                  maxQuantity,
                  true
                )
              );
            } else {
              items[i].push(
                new itemClassEdit(
                  this.item_list[i][j].id,
                  this.item_list[i][j].invoiceDocumentID,
                  this.item_list[i][j].customerMaterialNumber,
                  null,
                  this.item_list[i][j].itemID,
                  reason,
                  this.item_list[i][j].invoicedQuantity,
                  maxQuantity,
                  true
                )
              );
            }
          }
        }
      }

      for (let i in items) {
        for (let j in items[i]) {
          if (models[i].indexOf(items[i][j].modelNumber) == -1) {
            models[i].push(items[i][j].modelNumber);
          }
        }
      }

      for (let i in models) {
        for (let j in models[i]) {
          serials[i][models[i][j]] = [];
          qty[i][models[i][j]] = 0;

          for (let k in items) {
            for (let l in items[k]) {
              let rawSerial = {};
              if (models[i][j] == items[k][l].modelNumber) {
                qty[i][models[i][j]] += parseInt(items[k][l].invoicedQuantity);
                if (items[k][l].id) {
                  rawSerial["id"] = items[k][l].id;
                } else {
                  rawSerial["id"] = "";
                }
                if (items[k][l].serialNumber) {
                  rawSerial["value"] = items[k][l].serialNumber;
                } else {
                  rawSerial["value"] = "";
                }
                serials[i][models[i][j]].push(rawSerial);
              }
            }
          }
        }
      }

      for (let m in models) {
        for (let n in models[m]) {
          for (let i in items) {
            for (let j in items[i]) {
              if (models[m][n] == items[i][j].modelNumber) {
                final[i][j] = [];
                final[i][j] = items[i][j];
                break;
              }
            }
          }
        }
      }

      for (let f in final) {
        for (let g in final[f]) {
          for (let s in serials) {
            for (let t in serials[s]) {
              if (final[f][g].modelNumber == t) {
                final[f][g].invoicedQuantity = qty[s][t];
                final[f][g].serialNumber = serials[s][t];
              }
            }
          }
          itemList[f].push(final[f][g]);
        }
      }

      this.item_list = itemList;
      for (let i in this.item_list) {
        this.itemQuantityList[i] = [];
        for (let j in this.item_list[i]) {
          this.itemQuantityList[i][j] = [];
          let loopCount = 0;
          if (
            this.item_list[i][j].maxQuantity &&
            this.item_list[i][j].maxQuantity != ""
          ) {
            loopCount = parseInt(this.item_list[i][j].maxQuantity);
          } else {
            loopCount = this.item_list[i][j].invoicedQuantity;
          }
          for (var x = 0; x <= loopCount; x++) {
            this.itemQuantityList[i][j].push(x);
          }
        }
      }
      if (this.item_list && this.item_list.length > 0) {
        this.setItemList();
      }
    }
  }

  //Insert manually
  public addToList() {

const model = (this.modelNumber || '').trim().toUpperCase();
  const spare = (this.spareNumber || '').trim();
  const nc = (this.ncNumber || '').trim();

  this.modelNumber = model ? model : null;
  this.spareNumber = spare ? spare : null;
  this.ncNumber = nc ? nc : null;

    console.log(this.modelNumber);
    console.log(this.spareNumber);
    if (this.spareNumber !== null && this.modelNumber === null) {
      let modelCheck = false;
      console.log("1st")
      if (this.item_list.length > 0) {
        for (let i in this.item_list) {
          //check if same model number already exists
          if (this.item_list[i].spareNumber == this.spareNumber) {
            modelCheck = true;
            this.addToListModelExist(i);
          }
        }
      }
      // if same model number doesnt exist in item list
      if (!modelCheck) {
        this.addToListModelNew();
      }
    } else if (this.spareNumber === null && this.ncNumber !== null) {
      let modelCheck = false;
      console.log("2nd")
      // if (this.item_list.length > 0) {
      //     for (let i in this.item_list) {
      //         //check if same model number already exists
      //         if (this.item_list[i].spareNumber == this.spareNumber) {
      //             modelCheck = true;
      //             this.addToListModelExist(i);
      //         }
      //     }
      // }
      // if same model number doesnt exist in item list
      if (!modelCheck) {
        this.addToListModelNew();
      }
    } else if (this.modelNumber !== null && this.spareNumber === null) {
      let modelCheck = false;
      console.log("3rd")
      if (this.modelNumber && this.modelNumber != "") {
        this.modelNumber = this.modelNumber.toUpperCase();
        if (this.item_list.length > 0) {
          for (let i in this.item_list) {
            console.log(this.item_list);
            //this.item_list[i].invoicedQuantity = parseInt(this.itemQuantityList[i][this.itemQuantityList[i].length - 1]) + parseInt(this.quantity);
            // for (var x = 0; x <= this.item_list[i].invoicedQuantity; x++) {
            //     // this.itemQuantityList[i].push(x);//***Old one */
            //     //*** Check for duplicasy*/
            //     if (!this.itemQuantityList[i].includes(x)) {
            //         this.itemQuantityList[i].push(x);
            //     }
            // }
            //check if same model number already exists
            //  if (this.item_list[i].modelNumber == this.modelNumber) {
            //      modelCheck = true;
            //      this.addToListModelExist(i);
            //  }
          }
        }
        // if same model number doesnt exist in item list
        if (!modelCheck) {
          this.addToListModelNew();
        }
      }
    } else {
      this.showError(
        "Invalid Model Number. Please enter a valid model number.",
        false
      );
    }
  }

  public addToListModelNew() {
    if (this.spareNumber !== null && this.modelNumber === null) {
      if (!isNaN(this.quantitySpare)) {
        let items: itemClass[] = [];
        if (!this.serialNumberSpare || this.serialNumberSpare == "") {
          items.push(
            new itemClass("", this.spareNumber, "", "", this.quantitySpare, "")
          );
        } else {
          this.serialNumberSpare = this.serialNumberSpare.toUpperCase();
          if (this.SerialValidation(this.serialNumberSpare)) {
            items.push(
              new itemClass(
                "",
                this.spareNumber,
                this.serialNumberSpare,
                "",
                1,
                ""
              )
            );
          } else {
            this.showError(
              "Invalid Serial Number. Please enter valid serial number of length 9 or 10.",
              false
            );
            this.quantitySpare = 1;
            this.serialNumberSpare = null;
            this.showAddToListBtn = false;
          }
        }
        for (let i in items) {
          let serialNumberSpare = [];
          serialNumberSpare.push(this.serialNumberSpare);
          items[i].serialNumber = serialNumberSpare;
          this.item_list.push(items[i]);
        }
        if (this.item_list.length > 0) {
          for (let i in this.item_list) {
            if (!this.item_list[i].done) {
              this.listLoader[i] = true;
              this.itemQuantityList[i] = [];
              for (var x = 0; x <= this.item_list[i].invoicedQuantity; x++) {
                this.itemQuantityList[i].push(x);
              }
              this.get12NC(i, this.spareNumber);
            }
          }
        }
        let control = this.requestReturnForm.get("invoiceNumber");
        control.disable();
        this.showManualList = true;
      }
    } else if (this.modelNumber !== null && this.spareNumber === null) {
      if (!isNaN(this.quantity)) {
        let items: itemClass[] = [];
        if (!this.serialNumber || this.serialNumber == "") {
          items.push(
            new itemClass("", this.modelNumber, "", "", this.quantity, "")
          );
        } else {
          this.serialNumber = this.serialNumber.toUpperCase();
          if (this.SerialValidation(this.serialNumber)) {
            items.push(
              new itemClass("", this.modelNumber, this.serialNumber, "", 1, "")
            );
          } else {
            this.showError(
              "Invalid Serial Number. Please enter valid serial number of length 9 or 10.",
              false
            );
            this.quantity = 1;
            this.serialNumber = null;
            this.showAddToListBtn = false;
          }
        }
        for (let i in items) {
          let serialNumber = [];
          serialNumber.push(items[i].serialNumber);
          items[i].serialNumber = serialNumber;
          this.item_list.push(items[i]);
        }
        if (this.item_list.length > 0) {
          for (let i in this.item_list) {
            if (!this.item_list[i].done) {
              this.listLoader[i] = true;
              this.itemQuantityList[i] = [];
              for (var x = 0; x <= this.item_list[i].invoicedQuantity; x++) {
                this.itemQuantityList[i].push(x);
              }
              this.get12NC(i, this.modelNumber);
            }
          }
        }
        let control = this.requestReturnForm.get("invoiceNumber");
        control.disable();
        this.showManualList = true;
      }
    } else if (this.modelNumber !== null && this.spareNumber !== null) {
      if (!isNaN(this.quantitySpare)) {
        let items: itemClass[] = [];
        if (!this.serialNumberSpare || this.serialNumberSpare == "") {
          items.push(
            new itemClass("", this.spareNumber, "", "", this.quantitySpare, "")
          );
        } else {
          this.serialNumberSpare = this.serialNumberSpare.toUpperCase();
          if (this.SerialValidation(this.serialNumberSpare)) {
            items.push(
              new itemClass(
                "",
                this.spareNumber,
                this.serialNumberSpare,
                "",
                1,
                ""
              )
            );
          } else {
            this.showError(
              "Invalid Serial Number. Please enter valid serial number of length 9 or 10.",
              false
            );
            this.quantitySpare = 1;
            this.serialNumberSpare = null;
            this.showAddToListBtn = false;
          }
        }
        for (let i in items) {
          let serialNumberSpare = [];
          serialNumberSpare.push(this.serialNumberSpare);
          items[i].serialNumber = serialNumberSpare;
          this.item_list.push(items[i]);
        }
        if (this.item_list.length > 0) {
          for (let i in this.item_list) {
            if (!this.item_list[i].done) {
              this.listLoader[i] = true;
              this.itemQuantityList[i] = [];
              for (var x = 0; x <= this.item_list[i].invoicedQuantity; x++) {
                this.itemQuantityList[i].push(x);
              }
              this.get12NC(i, this.spareNumber);
            }
          }
        }
        let control = this.requestReturnForm.get("invoiceNumber");
        control.disable();
        this.showManualList = true;
      }
      if (!isNaN(this.quantity)) {
        let items: itemClass[] = [];
        if (!this.serialNumber || this.serialNumber == "") {
          items.push(
            new itemClass("", this.modelNumber, "", "", this.quantity, "")
          );
        } else {
          this.serialNumber = this.serialNumber.toUpperCase();
          if (this.SerialValidation(this.serialNumber)) {
            items.push(
              new itemClass("", this.modelNumber, this.serialNumber, "", 1, "")
            );
          } else {
            this.showError(
              "Invalid Serial Number. Please enter valid serial number of length 9 or 10.",
              false
            );
            this.quantity = 1;
            this.serialNumber = null;
            this.showAddToListBtn = false;
          }
        }
        for (let i in items) {
          let serialNumber = [];
          serialNumber.push(items[i].serialNumber);
          items[i].serialNumber = serialNumber;
          this.item_list.push(items[i]);
        }
        if (this.item_list.length > 0) {
          for (let i in this.item_list) {
            if (!this.item_list[i].done) {
              this.listLoader[i] = true;
              this.itemQuantityList[i] = [];
              for (var x = 0; x <= this.item_list[i].invoicedQuantity; x++) {
                this.itemQuantityList[i].push(x);
              }
              if (i === "1") {
                this.get12NC(i, this.modelNumber);
              }
            }
          }
        }
        let control = this.requestReturnForm.get("invoiceNumber");
        control.disable();
        this.showManualList = true;
      }
    }
    /// New code for 12NC search
    else if (this.ncNumber !== null && this.modelNumber === null) {
      if (!isNaN(this.quantityNC)) {
        let items: itemClass[] = [];
        if (!this.serialNumber12NC || this.serialNumber12NC == "") {
          items.push(
            new itemClass("", "", "", this.ncNumber, this.quantityNC, "")
          );
        } else {
          this.serialNumber12NC = this.serialNumber12NC.toUpperCase();
          if (this.SerialValidation(this.serialNumber12NC)) {
            items.push(
              new itemClass("", "", this.serialNumber12NC, this.ncNumber, 1, "")
            );
          } else {
            this.showError(
              "Invalid Serial Number. Please enter valid serial number of length 9 or 10.",
              false
            );
            this.quantityNC = 1;
            this.serialNumber12NC = null;
            this.showAddToListBtn = false;
          }
        }
        for (let i in items) {
          let serialNumber12NC = [];
          serialNumber12NC.push(this.serialNumber12NC);
          items[i].serialNumber = serialNumber12NC;
          this.item_list.push(items[i]);
        }
        if (this.item_list.length > 0) {
          for (let i in this.item_list) {
            if (!this.item_list[i].done) {
              this.listLoader[i] = true;
              this.itemQuantityList[i] = [];
              for (var x = 0; x <= this.item_list[i].invoicedQuantity; x++) {
                this.itemQuantityList[i].push(x);
              }
              this.get12NC(i, this.ncNumber);
            }
          }
        }
        let control = this.requestReturnForm.get("invoiceNumber");
        control.disable();
        this.showManualList = true;
      }
      // if (!isNaN(this.quantity)) {
      //     let items: itemClass[] = [];
      //     if (!this.serialNumber || this.serialNumber == '') {
      //         items.push(new itemClass('', this.modelNumber, '', '', this.quantity, ''));
      //     } else {
      //         this.serialNumber = this.serialNumber.toUpperCase();
      //         if (this.SerialValidation(this.serialNumber)) {
      //             items.push(new itemClass('', this.modelNumber, this.serialNumber, '', 1, ''));
      //         } else {
      //             this.showError('Invalid Serial Number. Please enter valid serial number of length 9 or 10.', false);
      //             this.quantity = 1;
      //             this.serialNumber = null;
      //             this.showAddToListBtn = false;
      //         }
      //     }
      //     for (let i in items) {
      //         let serialNumber = [];
      //         serialNumber.push(items[i].serialNumber);
      //         items[i].serialNumber = serialNumber;
      //         this.item_list.push(items[i]);
      //     }
      //     if (this.item_list.length > 0 ) {

      //         for (let i in this.item_list) {
      //             if (!this.item_list[i].done) {
      //                 this.listLoader[i] = true;
      //                 this.itemQuantityList[i] = [];
      //                 for (var x = 0; x <= this.item_list[i].invoicedQuantity; x++) {
      //                     this.itemQuantityList[i].push(x);
      //                 }
      //                 if(i==="1"){
      //                 this.get12NC(i, this.modelNumber);}
      //                 }
      //         }
      //     }
      //     let control = this.requestReturnForm.get('invoiceNumber');
      //     control.disable();
      //     this.showManualList = true;
      // }
    } else {
      this.showError("Invalid Quantity. Please enter a valid quantity.", false);
    }
  }

  // Function for 12NC search
  public save12NCSWAP(i, res) {
    this.listLoader[i] = false;
    this.item_list[i].done = true;
    for (let q in this.itemQuantityList[i]) {
      if (this.itemQuantityList[i][q] == this.item_list[i].invoicedQuantity) {
        this.itemQuantity[i] = this.itemQuantityList[i][q];
      }
    }

    if (parseInt(this.itemQuantity[i]) > 0) {
      this.enableItemReason[i] = true;
    }
    if (!this.itemReason[i] && this.return_reason) {
      this.itemReason[i] = this.return_reason;
    }
    if (res.status == "Success") {
      this.listValid[i] = true;
      if (res.items) {
        console.log(res);
        this.item_list[i].modelNumber = res.items[0];
        console.log(this.item_list);
        if (!this.serialNumber || this.serialNumber == "") {
          this.showEditSerial[i] = true;
        } else {
          this.showEditSerial[i] = false;
        }
        this.serialNumberList[i] = [];
        if (
          this.item_list[i].serialNumber &&
          this.item_list[i].serialNumber.length > 0 &&
          this.item_list[i].serialNumber[0]
        ) {
          let rawSerial: any = {};
          rawSerial.id = "";
          rawSerial.value = this.item_list[i].serialNumber[0];
          this.serialNumberList[i].push(rawSerial);
        }
      } else {
        this.showError("No item found for this model number", false);
      }
    } else {
      this.listValid[i] = false;
      this.enableItemReason[i] = false;
      this.listError[i] = res.errorMessage;
    }
    this.checkItemCountManual();
    this.quantity = 1;
    this.quantitySpare = 1;
    this.quantityNC = 1;
    this.modelNumber = null;
    this.spareNumber = null;
    this.serialNumber = null;
    this.serialNumberSpare = null;
    this.ncNumber = null;
    this.serialNumber12NC = null;
    this.showAddToListBtn = false;
  }

  public save12NC(i, res) {
    this.listLoader[i] = false;
    this.item_list[i].done = true;
    console.log(this.itemQuantityList)
    for (let q in this.itemQuantityList[i]) {
      console.log(q)
      if (this.itemQuantityList[i][q] == this.item_list[i].invoicedQuantity) {
        this.itemQuantity[i] = this.itemQuantityList[i][q];
      }
    }

    if (parseInt(this.itemQuantity[i]) > 0) {
      this.enableItemReason[i] = true;
    }
    if (!this.itemReason[i] && this.return_reason) {
      this.itemReason[i] = this.return_reason;
    }
    if (res.status == "Success") {
      this.listValid[i] = true;
      if (res.items) {
        this.item_list[i].itemID = res.items[0];
        if (!this.serialNumber || this.serialNumber == "") {
          this.showEditSerial[i] = true;
        } else {
          this.showEditSerial[i] = false;
        }
        this.serialNumberList[i] = [];
        if (
          this.item_list[i].serialNumber &&
          this.item_list[i].serialNumber.length > 0 &&
          this.item_list[i].serialNumber[0]
        ) {
          let rawSerial: any = {};
          rawSerial.id = "";
          rawSerial.value = this.item_list[i].serialNumber[0];
          this.serialNumberList[i].push(rawSerial);
        }
      } else {
        this.showError("No item found for this model number", false);
      }
    } else {
      this.listValid[i] = false;
      this.enableItemReason[i] = false;
      this.listError[i] = res.errorMessage;
    }
    this.checkItemCountManual();
    this.quantity = 1;
    this.quantitySpare = 1;
    this.quantityNC = 1;
    this.modelNumber = null;
    this.spareNumber = null;
    this.serialNumber = null;
    this.serialNumberSpare = null;
    this.showAddToListBtn = false;
    this.ncNumber = null;
    this.serialNumber12NC = null;
  }

  public addToListModelExist(i) {
    //if model number exist but row is valid
    if (this.listValid[i]) {
      //if model number exists and a new serial number is present
      if (this.serialNumber && this.serialNumber != "") {
        this.serialNumber = this.serialNumber.toUpperCase();
        if (this.SerialValidation(this.serialNumber)) {
          let count = 0;
          for (let s in this.serialNumberList[i]) {
            if (
              this.serialNumberList[i][s].value &&
              this.serialNumberList[i][s].value != ""
            ) {
              if (this.serialNumberList[i][s].value == this.serialNumber) {
                count++;
              }
            }
          }
          if (count == 0) {
            let rawSerial: any = {};
            rawSerial.id = "";
            rawSerial.value = this.serialNumber;
            this.serialNumberList[i].push(rawSerial);
            //increase qty+1 for item
            this.item_list[i].invoicedQuantity =
              parseInt(
                this.itemQuantityList[i][this.itemQuantityList[i].length - 1]
              ) + 1;
            for (var x = 0; x <= this.item_list[i].invoicedQuantity; x++) {
              // this.itemQuantityList[i].push(x);//***Old one */
              //*** Check for duplicasy*/
              if (!this.itemQuantityList[i].includes(x)) {
                this.itemQuantityList[i].push(x);
              }
            }
            for (let q in this.itemQuantityList[i]) {
              if (
                this.itemQuantityList[i][q] ==
                this.item_list[i].invoicedQuantity
              ) {
                this.itemQuantity[i] = this.itemQuantityList[i][q];
              }
            }
            this.listValid[i] = true;
            this.serialNumber = null;
            this.serialNumberSpare = null;
            this.modelNumber = null;
            this.spareNumber = null;
            this.quantity = 1;
            this.quantitySpare = 1;
          } else {
            this.showError(
              "Same serial number already exists for this model number. Please enter a different serial number.",
              false
            );
            this.serialNumber = null;
            this.serialNumberSpare = null;
            this.quantity = 1;
            this.quantitySpare = 1;
          }
          //this.compareSerialQuantity(i);
        } else {
          this.showError(
            "Invalid Serial Number. Please enter valid serial number of length 9 or 10.",
            false
          );
          this.serialNumber = null;
          this.serialNumberSpare = null;
          this.quantity = 1;
          this.quantitySpare = 1;
        }
      } else {
        //if model number exists but no serial number
        //increase qty for item
        this.item_list[i].invoicedQuantity =
          parseInt(
            this.itemQuantityList[i][this.itemQuantityList[i].length - 1]
          ) + parseInt(this.quantity);
        for (var x = 0; x <= this.item_list[i].invoicedQuantity; x++) {
          // this.itemQuantityList[i].push(x);//***Old one */
          //*** Check for duplicasy*/
          if (!this.itemQuantityList[i].includes(x)) {
            this.itemQuantityList[i].push(x);
          }
        }
        for (let q in this.itemQuantityList[i]) {
          if (
            this.itemQuantityList[i][q] == this.item_list[i].invoicedQuantity
          ) {
            this.itemQuantity[i] = this.itemQuantityList[i][q];
          }
        }
        //this.compareSerialQuantity(i);
        this.listValid[i] = true;
        this.serialNumber = null;
        this.serialNumberSpare = null;
        this.modelNumber = null;
        this.spareNumber = null;
        this.quantity = 1;
        this.quantitySpare = 1;
      }
    } else {
      this.showError("Invalid Model Number", false);
      this.quantity = 1;
      this.quantitySpare = 1;
      this.modelNumber = null;
      this.spareNumber = null;
      this.serialNumber = null;
      this.serialNumberSpare = null;
      this.showAddToListBtn = false;
    }

    console.log(this.itemQuantityList);
  }

  public checkQuantity(j, i) {
    if (this.itemQuantity[j][i] > 0) {
      this.item_list[j][i].invoicedQuantity = this.itemQuantity[j][i];
      this.enableItemReason[j][i] = true;
      this.item_list[j][i].valid = true;
      this.listValid[j][i] = true;
      this.setDefaultReason();
    } else {
      this.enableItemReason[j][i] = false;
      this.item_list[j][i].valid = false;
      this.listValid[j][i] = false;
      this.itemReason[j][i] = [];
      this.showEditSerial[j][i] = false;
      this.listError[j][i] =
        "To continue with this model number,minimum quantity should be 1.";
      this.showError(this.listError[j][i], false);
    }
    if (this.itemReason[j] && !this.itemReason[j][i] && this.return_reason) {
      this.itemReason[j][i] = this.return_reason;
    }
    this.checkItemCount();
  }

  public addSerialList(j, i) {
    if (parseInt(this.itemQuantity[j][i]) > 0) {
      if (this.serialNumberInput[j][i] && this.serialNumberInput[j][i] != "") {
        this.serialNumberInput[j][i] =
          this.serialNumberInput[j][i].toUpperCase();
        if (this.SerialValidation(this.serialNumberInput[j][i])) {
          let count = 0;
          for (let s in this.serialNumberList[j][i]) {
            if (
              this.serialNumberList[j][i][s].value &&
              this.serialNumberList[j][i][s].value != ""
            ) {
              if (
                this.serialNumberList[j][i][s].value ==
                this.serialNumberInput[j][i]
              ) {
                count++;
              }
            }
          }
          if (count == 0) {
            let rawSerial: any = {};
            rawSerial.id = "";
            rawSerial.value = this.serialNumberInput[j][i];
            this.serialNumberList[j][i].push(rawSerial);
          } else {
            this.showError(
              "Same serial number already exists for this model number. Please enter a different serial number.",
              false
            );
          }
          this.compareSerialQuantity(j, i);
        } else {
          this.showError(
            "Invalid Serial Number. Please enter valid serial number of length 9 or 10.",
            false
          );
        }
      }
    } else {
      this.showError("Please select quantity greater than 0.", false);
    }
    //input field blank
    this.serialNumberInput[j][i] = [];
  }

  public deleteSerialList(j, i, s, items) {
    delete this.serialNumberList[j][i][s];

    if (this.isUpload && !this.listValid[j][i]) {
      //TODO
      this.rearrangeList(i, items.modelNumber);
    } else {
      //rearrange index of serial list
      let dummy = [];
      for (let s in this.serialNumberList[j][i]) {
        if (this.serialNumberList[j][i][s]) {
          dummy.push(this.serialNumberList[j][i][s]);
        }
      }
      this.serialNumberList[j][i] = dummy;
      this.compareSerialQuantity(j, i);
    }
  }

  public delete(j, i) {
    this.itemQuantityList[j].splice(i, 1);
    this.itemQuantity[j].splice(i, 1);
    this.serialNumberList[j].splice(i, 1);
    this.serialNumberInput[j].splice(i, 1);
    this.showEditSerial[j].splice(i, 1);
    this.itemReason[j].splice(i, 1);
    this.listError.splice(i, 1);
    this.listValid[j].splice(i, 1);
    this.enableItemReason[j].splice(i, 1);
    this.item_list[j].splice(i, 1);
    this.checkItemCount();
  }

  public rearrangeList(index, modelNumber) {
    for (let i in this.item_list) {
      if (this.item_list[i].modelNumber == modelNumber) {
        this.item_list[i].invoicedQuantity =
          parseInt(this.item_list[i].invoicedQuantity) + 1;
        for (var x = 0; x <= this.item_list[i].invoicedQuantity; x++) {
          // this.itemQuantityList[i].push(x);//***Old one */
          //*** Check for duplicasy*/
          if (!this.itemQuantityList[i].includes(x)) {
            this.itemQuantityList[i].push(x);
          }
        }

        for (let q in this.itemQuantityList[i]) {
          if (
            this.itemQuantityList[i][q] == this.item_list[i].invoicedQuantity
          ) {
            this.itemQuantity[i] = this.itemQuantityList[i][q];
          }
        }
      }
    }

    this.itemQuantityList.splice(index, 1);
    this.itemQuantity.splice(index, 1);

    this.serialNumberList.splice(index, 1);
    this.serialNumberInput.splice(index, 1);
    this.showEditSerial.splice(index, 1);

    this.itemReason.splice(index, 1);
    this.listError.splice(index, 1);
    this.listValid.splice(index, 1);
    this.enableItemReason.splice(index, 1);
    this.item_list.splice(index, 1);

    //rearrange item list
    let dummy = [];
    for (let i in this.item_list) {
      if (this.item_list[i]) {
        dummy.push(this.item_list[i]);
      }
    }
    this.item_list = dummy;
    this.checkItemCount();
  }

  public compareSerialQuantity(i, j) {
    //compare serial count and quantity
    if (this.isEdit) {
      let count = 0;
      for (let s in this.serialNumberList[i][j]) {
        if (this.serialNumberList[i][j][s].value != "") {
          count++;
        }
      }
      if (count > parseInt(this.itemQuantity[i][j])) {
        this.showEditSerial[i][j] = false;
        this.showError(
          "Total count of serial numbers for item cannot be greater than item quantity. Please remove serial number(s) or change your quantity.",
          false
        );
        return false;
      }
      if (count < parseInt(this.itemQuantity[i][j])) {
        this.showEditSerial[i][j] = true;
        return true;
      }
      if (count == parseInt(this.itemQuantity[i][j])) {
        this.showEditSerial[i][j] = false;
        return true;
      }
    } else {
      if (
        this.serialNumberList[i][j] &&
        this.serialNumberList[i][j].length > parseInt(this.itemQuantity[i][j])
      ) {
        this.showEditSerial[i][j] = false;
        this.showError(
          "Total count of serial numbers for item cannot be greater than item quantity. Please remove serial number(s) or change your quantity.",
          false
        );
        return false;
      }
      if (
        this.serialNumberList[i][j] &&
        this.serialNumberList[i][j].length < parseInt(this.itemQuantity[i][j])
      ) {
        this.showEditSerial[i][j] = true;
        return true;
      }
      if (
        this.serialNumberList[i][j] &&
        this.serialNumberList[i][j].length == parseInt(this.itemQuantity[i][j])
      ) {
        this.showEditSerial[i][j] = false;
        return true;
      }
    }
  }

  public checkItemCount() {
    let validCount = 0;
    let qtyCount = 0;
    let serialCheck = [];
    let serialCount = 0;
    if (Object.keys(this.item_list).length > 0) {
      for (let i in this.item_list) {
        serialCheck.push([]);
        for (let j in this.item_list[i]) {
          if (this.listValid[i][j]) {
            validCount++;
            if (parseInt(this.itemQuantity[i][j]) > 0) {
              qtyCount++;
            }
            if (this.compareSerialQuantity(i, j)) {
              serialCheck[i][j] = true;
            } else {
              serialCheck[i][j] = false;
            }
          }
        }
      }
    }
    for (let s in serialCheck) {
      if (!serialCheck[s]) {
        serialCount++;
      }
    }
    if (
      validCount == 0 ||
      this.item_list.length == 0 ||
      qtyCount == 0 ||
      serialCount != 0
    ) {
      this.nextBtnEnable = false;
      // this.showInsertButton = true;
      // this.enableInvoiceCheck = true;
      let control = this.requestReturnForm.get("invoiceNumber");
      control.enable();
    } else {
      this.nextBtnEnable = true;
    }
  }

  public checkItemCountAfterNext() {
    let validCount = 0;
    let qtyCount = 0;
    let serialCheck = [];
    let serialCount = 0;
    if (Object.keys(this.item_list).length > 0) {
      for (let i in this.item_list) {
        for (let j in this.item_list[i]) {
          if (j == "data") {
            serialCheck.push([]);
            for (let k in this.item_list[i][j]) {
              if (this.listValid[i][k]) {
                validCount++;
                if (parseInt(this.itemQuantity[i][k]) > 0) {
                  qtyCount++;
                }
                if (this.compareSerialQuantity(i, k)) {
                  serialCheck[i][k] = true;
                } else {
                  serialCheck[i][k] = false;
                }
              }
            }
          }
        }
      }
    }
    for (let s in serialCheck) {
      if (!serialCheck[s]) {
        serialCount++;
      }
    }
    if (
      validCount == 0 ||
      this.item_list.length == 0 ||
      qtyCount == 0 ||
      serialCount != 0
    ) {
      this.nextBtnEnable = false;
      this.showInsertButton = true;
      this.enableInvoiceCheck = true;
      let control = this.requestReturnForm.get("invoiceNumber");
      control.enable();
    } else {
      this.nextBtnEnable = true;
    }
  }

  
public SerialValidation(value: string) {
    if (!value) return false;

    if (value.length === 9) {
        return /^[Ww][A-Za-z0-9]([0-4][0-9]|5[0-3])\d{5}$/.test(value);
    } else if (value.length === 10) {
        return /^[WwYyDd][A-Za-z][A-Za-z0-9]([0-4][0-9]|5[0-3])\d{5}$/.test(value);
    } else {
        return false;
    }
}

  public reset(method) {
    this.invoiceNo = [];
    this.showManualList = false;
    this.showInvoiceList = false;
    this.nextBtnEnable = false;
    this.modelNumber = null;
    this.spareNumber = null;
    this.spareList = [];
    this.serialNumber = null;
    this.serialNumberSpare = null;
    this.quantity = "1";
    this.quantitySpare = 1;
    this.items = [];
    this.last_index = 0;
    this.item_list = [];
    this.enableItemReason = [];
    this.listValid = [];
    this.itemReason = [];
    this.serialNumberList = [];
    this.serialNumberInput = [];
    this.itemQuantityList = [];
    this.itemQuantity = [];
    this.showEditSerial = [];
    this.listLoader = [];
    this.resetInvoieFields();
    this.enableInvoiceCheck = false;
    if (method == "invoice") {
      this.isManual = false;
      this.isUpload = false;
      this.showInsertButton = true;
      this.showInvoiceReturn = false;
      this.invoiceBtnEnable = false;
      this.invoice_no_array = [];
      let control = this.requestReturnForm.get("invoiceNumber");
      control.enable();
    }
    if (method == "manual") {
      this.isManual = true;
      this.isUpload = false;
      this.invoiceBtnEnable = true;
      let control = this.requestReturnForm.get("invoiceNumber");
      control.disable();
    }
    if (method == "upload") {
      this.isUpload = true;
      this.isManual = false;
      this.invoiceBtnEnable = true;
      let control = this.requestReturnForm.get("invoiceNumber");
      control.disable();
    }
  }

  public setDefaultReason() {
    if (Object.keys(this.item_list).length > 0) {
      for (let i in this.item_list) {
        for (let j in this.item_list[i]) {
          if (
            !this.itemReason[i][j] &&
            this.return_reason &&
            this.listValid[i][j]
          ) {
            this.itemReason[i][j] = this.return_reason;
          }
        }
      }
    }
  }

  public showManualItemError(i) {
    this.dialogRef = this.dialog.open(dialogComponent, { disableClose: true });
    this.dialogRef.componentInstance.msg = this.listError[i];
  }

  public showError(msg, isLogout) {
    this.dialogRef = this.dialog.open(dialogComponent, { disableClose: true });
    this.dialogRef.componentInstance.msg = msg;
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (isLogout) {
          localStorage.clear();
          this.router.navigateByUrl("/login");
        }
      }
      this.dialogRef = null;
    });
  }

  public isItemInArray(array, item) {
    for (var i = 0; i < array.length; i++) {
      // This if statement depends on the format of your array
      if (array[i].value == item) {
        return true; // Found it
      }
    }
    return false; // Not found
  }

  public setFormDetails() {
    let count = 0;
    let qtyList: any = [];
    let selected_items = [];
    if (Object.keys(this.item_list).length > 0) {
      for (let i in this.item_list) {
        qtyList[i] = [];
        let count1 = 0;
        selected_items[i] = {};

        for (let j in this.item_list[i]) {
          if (
            this.listValid[i][j] &&
            parseInt(this.item_list[i][j].invoicedQuantity) > 0
          ) {
            this.item_list[i][j].invoicedQuantity = this.itemQuantity[i][j];
            count += parseInt(this.item_list[i][j].invoicedQuantity);

            qtyList[i].push(this.itemQuantityList[i][j]);
            this.item_list[i][j].maxQuantity =
              this.itemQuantityList[i][j][
                this.itemQuantityList[i][j].length - 1
              ];

            if (this.itemReason[i] && this.itemReason[i].length > 0) {
              this.item_list[i][j].reasonCode = this.itemReason[i][j];
            } else {
              this.item_list[i][j].reasonCode = "";
            }
            this.item_list[i][j].serialNumber = this.serialNumberList[i][j];

            selected_items[i]["invoiceNumber"] =
              this.item_list[i][j].invoiceNumber;
            if (count1 == 0) {
              selected_items[i]["data"] = [];
              //selected_items[i]['data'][i] = [];
              count1++;
            }
            if (selected_items[i]["data"]) {
              selected_items[i]["data"].push(this.item_list[i][j]);
            }
          }
        }
      }

      let dummy_selected_items = [];
      if (selected_items) {
        for (let i in selected_items) {
          if (Object.keys(selected_items[i]).length > 0) {
            dummy_selected_items.push(selected_items[i]);
          }
        }
      }

      if (qtyList) {
        let j: any;
        for (j = 0; j < qtyList.length; j++) {
          if (Object.keys(qtyList[j]).length <= 0) {
            qtyList.splice(j, 1);
            j--;
          }
        }
      }

      this.sessionHandler.saveItem("itemList", JSON.stringify(qtyList));
      if (this.isManual) {
        this.requestFormData["returnItemUploadFlag"] = 0;
      }
      if (this.isUpload) {
        this.requestFormData["returnItemUploadFlag"] = 1;
      }
      if (this.invoice_no.length > 0) {
        this.requestFormData["returnItemUploadFlag"] = 2;
      }
      this.requestFormData["returnOrder"]["items"] = dummy_selected_items;
      if (count == 0) {
        this.showError("Please add atleast one valid item", false);
      } else if (
        !this.isD2CUser &&
        this.requestFormData &&
        (!this.requestFormData["requestOrder"].palletSelected ||
          this.requestFormData["requestOrder"].palletSelected == "false") &&
        count > parseInt(this.requestFormData["requestOrder"].parcels)
      ) {
        this.dialogRef = this.dialog.open(dialogComponent, {
          disableClose: true,
        });
        this.dialogRef.componentInstance.msg =
          "Quantity of returned item(s) is more than the number of parcels mentioned before. \n\n Are you sure you want to continue?";
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.commonService.setData(this.requestFormData);
            if (!isNaN(this.id)) {
              this.router.navigateByUrl("/app/requests/confirm/" + this.id);
            } else {
              this.router.navigateByUrl("/app/requests/confirm");
            }
          }
          this.dialogRef = null;
        });
      } else if (
        !this.isD2CUser &&
        this.requestFormData["requestOrder"].palletSelected == "false" &&
        count < parseInt(this.requestFormData["requestOrder"].parcels)
      ) {
        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg =
          "Quantity of return item(s) cannot be less than number of parcels mention before.";
        return false;
      } else {
        return true;
      }
    } else {
      this.showError("Please add atleast one valid item.", false);
      return false;
    }
  }

  public goToNextPage() {
    this.requestFormData["returnOrder"] = this.requestReturnForm.getRawValue();
    if (this.isManual || this.isUpload) {
      if (this.setFormDetailsManual()) {
        this.commonService.setData(this.requestFormData);
        if (!isNaN(this.id)) {
          this.router.navigateByUrl("/app/requests/confirm/" + this.id);
        } else {
          this.router.navigateByUrl("/app/requests/confirm");
        }
      }
    } else if (this.setFormDetails()) {
      this.commonService.setData(this.requestFormData);
      if (!isNaN(this.id)) {
        this.router.navigateByUrl("/app/requests/confirm/" + this.id);
      } else {
        this.router.navigateByUrl("/app/requests/confirm");
      }
    }
  }
  private persistReturnPageDataBeforeNavigation(): void {
  if (!this.requestFormData) {
    return;
  }

  // Save form values like reason, foc, d2c comments, invoice number etc.
  this.requestFormData["returnOrder"] = this.requestReturnForm.getRawValue();

  // Save selected entry mode
 if (this.isManual) {
  this.requestFormData["returnItemUploadFlag"] = 0;
} else if (this.isUpload) {
  this.requestFormData["returnItemUploadFlag"] = 1;
} else if (
  this.showInvoiceReturn ||
  this.showInvoiceList ||
  (this.invoice_no && this.invoice_no.length > 0) ||
  (this.invoice_no_array && this.invoice_no_array.length > 0)
) {
  this.requestFormData["returnItemUploadFlag"] = 2;
} else {
  this.requestFormData["returnItemUploadFlag"] = null;
}

  // Preserve existing returnOrder object
  if (!this.requestFormData["returnOrder"]) {
    this.requestFormData["returnOrder"] = {};
  }

  // Persist invoice/manual/upload selected items without validation
  this.requestFormData["returnOrder"]["items"] = this.item_list || [];

  // Persist invoice numbers also
  if (this.invoice_no && this.invoice_no.length > 0) {
    this.requestFormData["returnOrder"]["invoiceNumber"] = this.invoice_no;
  } else if (this.invoiceNo && this.invoiceNo.length > 0) {
    this.requestFormData["returnOrder"]["invoiceNumber"] = this.invoiceNo;
  }

  // Persist current reason
  if (this.return_reason) {
    this.requestFormData["returnOrder"]["reason"] = this.return_reason;
  }

  // Persist serials, quantity and reason into item_list for manual/upload flow
  if (this.isManual || this.isUpload) {
    for (let i in this.item_list) {
      if (this.item_list[i]) {
        if (this.itemQuantity && this.itemQuantity[i] !== undefined) {
          this.item_list[i].invoicedQuantity = this.itemQuantity[i];
        }

        if (this.itemReason && this.itemReason[i] !== undefined) {
          this.item_list[i].reasonCode = this.itemReason[i];
        }

        if (this.serialNumberList && this.serialNumberList[i] !== undefined) {
          this.item_list[i].serialNumber = this.serialNumberList[i];
        }

        if (
          this.itemQuantityList &&
          this.itemQuantityList[i] &&
          this.itemQuantityList[i].length > 0
        ) {
          this.item_list[i].maxQuantity =
            this.itemQuantityList[i][this.itemQuantityList[i].length - 1];
        }
      }
    }

    this.requestFormData["returnOrder"]["items"] = this.item_list;
    this.sessionHandler.saveItem(
      "itemList",
      JSON.stringify(this.itemQuantityList || [])
    );
  }

  // Persist invoice flow nested items
  if (!this.isManual && !this.isUpload) {
    for (let i in this.item_list) {
      if (this.item_list[i]) {
        for (let j in this.item_list[i]) {
          if (this.item_list[i][j]) {
            if (
              this.itemQuantity &&
              this.itemQuantity[i] &&
              this.itemQuantity[i][j] !== undefined
            ) {
              this.item_list[i][j].invoicedQuantity = this.itemQuantity[i][j];
            }

            if (
              this.itemReason &&
              this.itemReason[i] &&
              this.itemReason[i][j] !== undefined
            ) {
              this.item_list[i][j].reasonCode = this.itemReason[i][j];
            }

            if (
              this.serialNumberList &&
              this.serialNumberList[i] &&
              this.serialNumberList[i][j] !== undefined
            ) {
              this.item_list[i][j].serialNumber = this.serialNumberList[i][j];
            }

            if (
              this.itemQuantityList &&
              this.itemQuantityList[i] &&
              this.itemQuantityList[i][j] &&
              this.itemQuantityList[i][j].length > 0
            ) {
              this.item_list[i][j].maxQuantity =
                this.itemQuantityList[i][j][
                  this.itemQuantityList[i][j].length - 1
                ];
            }
          }
        }
      }
    }

    this.requestFormData["returnOrder"]["items"] = this.item_list;
    this.sessionHandler.saveItem(
      "itemList",
      JSON.stringify(this.itemQuantityList || [])
    );
  }

  // Finally save into common service
  this.commonService.setData(this.requestFormData);
}

  public goToPreviousPage() {
   this.persistReturnPageDataBeforeNavigation();
    if (!isNaN(this.id)) {
      this.router.navigateByUrl("/app/requests/create/" + this.id);
    } else {
      this.router.navigateByUrl("/app/requests/create");
    }
  }

  //FOR MANUAL ENTRIES
  public setReturnDataManual() {
    this.return_reason = this.returnOrder.reason;
    if (
      this.requestFormData.returnItemUploadFlag == "INSERT_MANUAL" ||
      this.requestFormData.returnItemUploadFlag == "0" ||
      this.requestFormData.returnItemUploadFlag == 0
    ) {
      if (this.requestReturnForm) {
        let control = this.requestReturnForm.get("invoiceNumber");
        control.disable();
      }
      this.isManual = true;
      this.invoiceBtnEnable = true;
    } else if (
      this.requestFormData.returnItemUploadFlag == "UPLOAD_FILE" ||
      this.requestFormData.returnItemUploadFlag == "1" ||
      this.requestFormData.returnItemUploadFlag == 1
    ) {
      if (this.requestReturnForm) {
        let control = this.requestReturnForm.get("invoiceNumber");
        control.disable();
      }
      this.isUpload = true;
      this.invoiceBtnEnable = true;
    } else if (
      this.requestFormData.returnItemUploadFlag == "INVOICE_NUMBER" ||
      this.requestFormData.returnItemUploadFlag == "2" ||
      this.requestFormData.returnItemUploadFlag == 2
    ) {
      this.invoice_no = this.returnOrder.invoiceNumber;
      this.showInsertButton = false;
      this.showInvoiceReturn = true;
    } else {
      if (this.requestReturnForm) {
        let control = this.requestReturnForm.get("invoiceNumber");
        control.disable();
      }
      this.isManual = true;
      this.invoiceBtnEnable = true;
    }

    let localItemList = JSON.parse(this.sessionHandler.getItem("itemList"));
    for (let i in localItemList) {
      this.itemQuantityList[i] = [];
      for (var x = 0; x <= localItemList[i].length - 1; x++) {
        // this.itemQuantityList[i].push(x);//***Old one */
        //*** Check for duplicasy*/
        if (!this.itemQuantityList[i].includes(x)) {
          this.itemQuantityList[i].push(x);
        }
      }
    }
    if (this.returnOrder.items) {
      this.item_list = Object.assign([], this.returnOrder.items);
      this.nextBtnEnable = true;
      if (this.item_list && this.item_list.length > 0) {
        if (this.item_list[0].modelNumber) {
          this.setItemListManual();
        } else {
          this.setItemDataForEditManual();
        }
      }
    }
    this.showManualList = true;
  }

  public addSerialListManual(i) {
    if (parseInt(this.itemQuantity[i]) > 0) {
      if (this.serialNumberInput[i] && this.serialNumberInput[i] != "") {
        this.serialNumberInput[i] = this.serialNumberInput[i].toUpperCase();
        if (this.SerialValidation(this.serialNumberInput[i])) {
          let count = 0;
          for (let s in this.serialNumberList[i]) {
            if (
              this.serialNumberList[i][s].value &&
              this.serialNumberList[i][s].value != ""
            ) {
              if (
                this.serialNumberList[i][s].value == this.serialNumberInput[i]
              ) {
                count++;
              }
            }
          }
          if (count == 0) {
            let rawSerial: any = {};
            rawSerial.id = "";
            rawSerial.value = this.serialNumberInput[i];
            this.serialNumberList[i].push(rawSerial);
          } else {
            this.showError(
              "Same serial number already exists for this model number. Please enter a different serial number.",
              false
            );
          }
          this.compareSerialQuantityManual(i);
        } else {
          this.showError(
            "Invalid Serial Number. Please enter valid serial number of length 9 or 10.",
            false
          );
        }
      }
    } else {
      this.showError("Please select quantity greater than 0.", false);
    }
    //input field blank
    this.serialNumberInput = [];
  }

  public setDefaultReasonManual() {
    if (Object.keys(this.item_list).length > 0) {
      for (let i in this.item_list) {
        if (!this.itemReason[i] && this.return_reason && this.listValid[i]) {
          this.itemReason[i] = this.return_reason;
        }
      }
    }
  }

  public compareSerialQuantityManual(i) {
    //compare serial count and quantity
    if (this.isEdit) {
      let count = 0;
      for (let s in this.serialNumberList[i]) {
        if (this.serialNumberList[i][s].value != "") {
          count++;
        }
      }
      if (count > parseInt(this.itemQuantity[i])) {
        this.showEditSerial[i] = false;
        this.showError(
          "Total count of serial numbers for item cannot be greater than item quantity. Please remove serial number(s) or change your quantity.",
          false
        );
        return false;
      }
      if (count < parseInt(this.itemQuantity[i])) {
        this.showEditSerial[i] = true;
        return true;
      }
      if (count == parseInt(this.itemQuantity[i])) {
        this.showEditSerial[i] = false;
        return true;
      }
    } else {
      if (
        this.serialNumberList[i] &&
        this.serialNumberList[i].length > parseInt(this.itemQuantity[i])
      ) {
        this.showEditSerial[i] = false;
        this.showError(
          "Total count of serial numbers for item cannot be greater than item quantity. Please remove serial number(s) or change your quantity.",
          false
        );
        return false;
      }
      if (
        this.serialNumberList[i] &&
        this.serialNumberList[i].length < parseInt(this.itemQuantity[i])
      ) {
        this.showEditSerial[i] = true;
        return true;
      }
      if (
        this.serialNumberList[i] &&
        this.serialNumberList[i].length == parseInt(this.itemQuantity[i])
      ) {
        this.showEditSerial[i] = false;
        return true;
      }
    }
  }

  public deleteSerialListManual(i, s, items) {
    delete this.serialNumberList[i][s];
    if (this.isUpload && !this.listValid[i]) {
      this.rearrangeList(i, items.modelNumber);
    } else {
      //rearrange index of serial list
      let dummy = [];
      for (let s in this.serialNumberList[i]) {
        if (this.serialNumberList[i][s]) {
          dummy.push(this.serialNumberList[i][s]);
        }
      }
      this.serialNumberList[i] = dummy;
      this.compareSerialQuantityManual(i);
    }
  }

  public checkQuantityManual(i) {
    if (this.itemQuantity[i] > 0) {
      this.item_list[i].invoicedQuantity = this.itemQuantity[i];
      this.enableItemReason[i] = true;
      this.item_list[i].valid = true;
      this.listValid[i] = true;
    } else {
      this.enableItemReason[i] = false;
      this.item_list[i].valid = false;
      this.listValid[i] = false;
      this.itemReason[i] = [];
      this.showEditSerial[i] = false;
      this.listError[i] =
        "To continue with this model number,minimum quantity should be 1.";
    }
    if (!this.itemReason[i] && this.return_reason) {
      this.itemReason[i] = this.return_reason;
    }
    this.checkItemCountManual();
  }

  public checkItemCountManual() {
    let validCount = 0;
    let qtyCount = 0;
    let serialCheck = [];
    let serialCount = 0;
    if (Object.keys(this.item_list).length > 0) {
      for (let i in this.item_list) {
        if (this.listValid[i]) {
          validCount++;
          if (parseInt(this.itemQuantity[i]) > 0) {
            qtyCount++;
          }
          if (this.compareSerialQuantityManual(i)) {
            serialCheck[i] = true;
          } else {
            serialCheck[i] = false;
          }
        }
      }
    }
    for (let s in serialCheck) {
      if (!serialCheck[s]) {
        serialCount++;
      }
    }
    if (
      validCount == 0 ||
      this.item_list.length == 0 ||
      qtyCount == 0 ||
      serialCount != 0
    ) {
      this.nextBtnEnable = false;
      this.showInsertButton = true;
      this.enableInvoiceCheck = true;
      let control = this.requestReturnForm.get("invoiceNumber");
      control.enable();
    } else {
      this.nextBtnEnable = true;
    }
  }
  public deleteManual(index) {
    this.itemQuantityList.splice(index, 1);
    this.itemQuantity.splice(index, 1);

    this.serialNumberList.splice(index, 1);
    this.serialNumberInput.splice(index, 1);
    this.showEditSerial.splice(index, 1);

    this.itemReason.splice(index, 1);
    this.listError.splice(index, 1);
    this.listValid.splice(index, 1);
    this.enableItemReason.splice(index, 1);
    this.item_list.splice(index, 1);
    this.checkItemCountManual();
  }

  public setFormDetailsManual() {
    let count = 0;
    let qtyList = [];
    let selected_items = [];
    if (Object.keys(this.item_list).length > 0) {
      for (let i in this.item_list) {
        if (
          this.listValid[i] &&
          parseInt(this.item_list[i].invoicedQuantity) > 0
        ) {
          this.item_list[i].invoicedQuantity = this.itemQuantity[i];
          count += parseInt(this.item_list[i].invoicedQuantity);
          qtyList.push(this.itemQuantityList[i]);
          this.item_list[i].maxQuantity =
            this.itemQuantityList[i][this.itemQuantityList[i].length - 1];
          if (this.itemReason[i] && this.itemReason[i].length > 0) {
            this.item_list[i].reasonCode = this.itemReason[i];
          } else {
            this.item_list[i].reasonCode = "";
          }
          this.item_list[i].serialNumber = this.serialNumberList[i];
          selected_items.push(this.item_list[i]);
        }
      }
      this.sessionHandler.saveItem("itemList", JSON.stringify(qtyList));
      if (this.isManual) {
        this.requestFormData["returnItemUploadFlag"] = 0;
      }
      if (this.isUpload) {
        this.requestFormData["returnItemUploadFlag"] = 1;
      }
      if (this.invoice_no.length > 0) {
        this.requestFormData["returnItemUploadFlag"] = 2;
      }
      this.requestFormData["returnOrder"]["items"] = selected_items;
      if (count == 0) {
        this.showError("Please add atleast one valid item", false);
      } else if (
        !this.isD2CUser &&
        this.requestFormData &&
        (!this.requestFormData["requestOrder"].palletSelected ||
          this.requestFormData["requestOrder"].palletSelected == "false") &&
        count > parseInt(this.requestFormData["requestOrder"].parcels)
      ) {
        this.dialogRef = this.dialog.open(dialogComponent, {
          disableClose: true,
        });
        this.dialogRef.componentInstance.msg =
          "Quantity of returned item(s) is more than the number of parcels mentioned before. \n\n Are you sure you want to continue?";
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.commonService.setData(this.requestFormData);
            if (!isNaN(this.id)) {
              this.router.navigateByUrl("/app/requests/confirm/" + this.id);
            } else {
              this.router.navigateByUrl("/app/requests/confirm");
            }
          }
          this.dialogRef = null;
        });
      } else if (
        !this.isD2CUser &&
        this.requestFormData["requestOrder"].palletSelected == "false" &&
        count < parseInt(this.requestFormData["requestOrder"].parcels)
      ) {
        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg =
          "Quantity of return item(s) cannot be less than number of parcels mention before.";
        return false;
      } else {
        return true;
      }
    } else {
      this.showError("Please add atleast one valid item.", false);
      return false;
    }
  }

  public setItemListManual() {
    for (let i in this.item_list) {
      if (parseInt(this.item_list[i].invoicedQuantity) > 0) {
        this.enableItemReason[i] = true;
        this.listValid[i] = true;
        this.showEditSerial[i] = false;
        this.serialNumberList[i] = [];
        if (this.isManual) {
          this.item_list[i].done = true;
        }
        if (
          this.item_list[i].serialNumber &&
          Object.keys(this.item_list[i].serialNumber).length > 0
        ) {
          for (let x in this.item_list[i].serialNumber) {
            if (
              this.item_list[i].serialNumber[x] &&
              Object.keys(this.item_list[i].serialNumber[x]).length > 0
            ) {
              if (
                !this.isItemInArray(
                  this.serialNumberList[i],
                  this.item_list[i].serialNumber[x].value
                )
              ) {
                this.serialNumberList[i].push(
                  this.item_list[i].serialNumber[x]
                );
              }
            }
          }
        }
        for (let q in this.itemQuantityList[i]) {
          if (
            this.itemQuantityList[i][q] == this.item_list[i].invoicedQuantity
          ) {
            this.itemQuantity[i] = this.itemQuantityList[i][q];
          }
        }
        let count = 0;
        for (let x in this.serialNumberList[i]) {
          if (
            this.serialNumberList[i][x].value &&
            this.serialNumberList[i][x].value != ""
          ) {
            count++;
          }
        }
        if (count < parseInt(this.item_list[i].invoicedQuantity)) {
          this.showEditSerial[i] = true;
        }
        if (this.item_list[i].reasonCode) {
          this.itemReason[i] = this.item_list[i].reasonCode;
        }
      }
    }
  }

  public setItemDataForEditManual() {
    if (this.item_list) {
      let serials: any = [];
      let qty: any = [];
      let models: any = [];
      let final: any = [];
      let items: itemClassEditManual[] = [];
      let itemList: any = [];
      for (let i in this.item_list) {
        if (this.item_list[i]) {
          if (!this.item_list[i].id) {
            this.item_list[i].id = "";
          }
          let reason = null;
          if (this.item_list[i].reasonCode) {
            reason = this.item_list[i].reasonCode;
          }
          let maxQuantity = "";
          if (
            this.item_list[i].maxQuantity &&
            this.item_list[i].maxQuantity != ""
          ) {
            maxQuantity = this.item_list[i].maxQuantity;
          }
          if (this.item_list[i].serialNumber) {
            items.push(
              new itemClassEditManual(
                this.item_list[i].id,
                this.item_list[i].customerMaterialNumber,
                this.item_list[i].serialNumber,
                this.item_list[i].itemID,
                reason,
                this.item_list[i].invoicedQuantity,
                maxQuantity,
                true
              )
            );
          } else {
            items.push(
              new itemClassEditManual(
                this.item_list[i].id,
                this.item_list[i].customerMaterialNumber,
                null,
                this.item_list[i].itemID,
                reason,
                this.item_list[i].invoicedQuantity,
                maxQuantity,
                true
              )
            );
          }
        }
      }

      for (let i in items) {
        if (models.indexOf(items[i].modelNumber) == -1) {
          models.push(items[i].modelNumber);
        }
      }

      for (let m in models) {
        serials[models[m]] = [];
        qty[models[m]] = 0;
        for (let i in items) {
          let rawSerial = {};
          if (models[m] == items[i].modelNumber) {
            qty[models[m]] += parseInt(items[i].invoicedQuantity);
            if (items[i].id) {
              rawSerial["id"] = items[i].id;
            } else {
              rawSerial["id"] = "";
            }
            if (items[i].serialNumber && String(items[i].serialNumber).trim() !== '') {
              rawSerial["value"] = items[i].serialNumber;
            } else {
              rawSerial["value"] = "";
            }
            serials[models[m]].push(rawSerial);
          }
        }
      }

      for (let m in models) {
        for (let i in items) {
          if (models[m] == items[i].modelNumber) {
            final[i] = [];
            final[i] = items[i];
            break;
          }
        }
      }

      for (let f in final) {
        for (let s in serials) {
          if (final[f].modelNumber == s) {
            final[f].invoicedQuantity = qty[s];
            final[f].serialNumber = serials[s];
          }
        }
        itemList.push(final[f]);
      }
      this.item_list = itemList;

      for (let i in this.item_list) {
        this.itemQuantityList[i] = [];
        let loopCount = 0;
        if (
          this.item_list[i].maxQuantity &&
          this.item_list[i].maxQuantity != ""
        ) {
          loopCount = parseInt(this.item_list[i].maxQuantity);
        } else {
          loopCount = this.item_list[i].invoicedQuantity;
        }
        for (var x = 0; x <= loopCount; x++) {
          // this.itemQuantityList[i].push(x);//***Old one */
          //*** Check for duplicasy*/
          if (!this.itemQuantityList[i].includes(x)) {
            this.itemQuantityList[i].push(x);
          }
        }
      }
      if (this.item_list && this.item_list.length > 0) {
        this.setItemListManual();
      }
    }
  }
  // END Maual Functions
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/request-mgmt/return/return.component.ts